import {Product} from 'models/product.model';
import {callApi} from './api';

export const fetchProductRequest = async (productId: number): Promise<Product> => {
  return callApi<Product>(`/products/${productId}`, {}).then(({data}) => data);
};
